var utils = {
    serializeForm: function ( form ) {
        var serialized = [];
        for ( var i = 0; i < form.elements.length; i++ ) {

            var field = form.elements[ i ];
            if ( !field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button' ) {
                continue;
            }
            else if ( ( field.type !== 'checkbox' && field.type !== 'radio' ) || field.checked ) {
                serialized.push( encodeURIComponent( field.name ) + "=" + encodeURIComponent( field.value ) );
            }
        }
        return serialized.join( '&' );
    },
    isNullOrUndefined: function ( elem ) {
        return elem === null || elem === undefined;
    },
    require: function ( path, fnCallback ) {
        var script = document.createElement( 'script' );
        var prior = document.getElementsByTagName( 'script' )[ 0 ];
        script.async = 1;

        script.onload = script.onreadystatechange = function ( _, isAbort ) {
            if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
                script.onload = script.onreadystatechange = null;
                script = undefined;

                if ( !isAbort && fnCallback ) {
                    setTimeout( fnCallback, 0 );
                }
            }
        };

        script.src = path;
        prior.parentNode.insertBefore( script, prior );
    }
};


var dvf = {
    init: function () {
        dvf.dealersearch.init();
    },
    dealersearch: {
        selectors: {
            form: 'js-dvf-dealersearch-form',
            zipcode: 'zipcode'
        },
        settings: {
            url: '/system/data/dealersearch',
            handlebars: '/Files/System/espresso/design/_assets/js/vendor/handlebars.js'
        },
        hbs: {
            results: {
                tpl: 'dvf-dealersearch-hbs-results-template',
                container: 'dvf-dealersearch-hbs-results-container',
                compiled: null
            },
            zipcodes: {
                tpl: 'dvf-dealersearch-hbs-zip-template',
                container: 'dvf-dealersearch-hbs-zip-container',
                compiled: null
            },
            compile: function () {
                var hbsResultsTemplate = document.getElementById( dvf.dealersearch.hbs.results.tpl ),
                    hbsZipTemplate = document.getElementById( dvf.dealersearch.hbs.zipcodes.tpl );
                dvf.dealersearch.hbs.results.compiled = Handlebars.compile( hbsResultsTemplate.innerHTML );
                dvf.dealersearch.hbs.zipcodes.compiled = Handlebars.compile( hbsZipTemplate.innerHTML );
            }
        },
        init: function () {
            var searchForm = document.getElementById( dvf.dealersearch.selectors.form );
            if ( utils.isNullOrUndefined( searchForm ) === false ) {
                dvf.dealersearch.bindEvents( searchForm );
                utils.require( dvf.dealersearch.settings.handlebars, function () {
                    dvf.dealersearch.hbs.compile();
                    dvf.dealersearch.query( null, true );
                } );
            }

        },
        bindEvents: function ( searchForm ) {
            var searchInput = searchForm.querySelector( '.js-dvf-search-input' ),
                searchClear = searchForm.querySelector( '.js-dvf-search-clear' );
            searchInput.addEventListener( 'input', function ( event ) {
                if ( event.target.value.length === 0 ) {
                    searchClear.classList.add( 'hide' );
                }
                else {
                    searchClear.classList.remove( 'hide' );
                }
            } );

            searchForm.addEventListener( 'submit', function ( event ) {
                event.preventDefault();
                dvf.dealersearch.query( searchForm, false );
            } );
            searchForm.addEventListener( 'change', function ( event ) {
                for ( var target = event.target; target && target !== this; target = target.parentNode ) {
                    if ( target.matches( '#' + dvf.dealersearch.selectors.zipcode ) ) {
                        dvf.dealersearch.query( searchForm, false );
                        break;
                    }
                }
            } );
            searchClear.addEventListener( 'click', function () {
                var submitEvent = new Event( 'submit' ),
                    inputEvent = new Event( 'input' ),
                    zipSelect = document.getElementById( dvf.dealersearch.selectors.zipcode )
                searchInput.value = '';
                zipSelect.selectedIndex = 0;
                searchInput.dispatchEvent( inputEvent );
                searchForm.dispatchEvent( submitEvent );
            } );

            searchInput.focus();
        },
        query: function ( searchForm, isInitialPost ) {
            var xhr = new XMLHttpRequest(),
                formData = '';
            if ( utils.isNullOrUndefined( searchForm ) === false ) {
                formData = utils.serializeForm( searchForm );
            }

            xhr.open( 'GET', dvf.dealersearch.settings.url + '?' + formData );
            xhr.setRequestHeader( 'Content-Type', 'application/json;charset=UTF-8' );
            xhr.onload = function () {
                if ( xhr.status === 200 ) {
                    var jsonData = JSON.parse( xhr.responseText );
                    dvf.dealersearch.build( jsonData, isInitialPost );
                }
                else if ( xhr.status !== 200 ) {
                    console.error( 'Request failed.  Returned status of ' + xhr.status );
                }
            };
            xhr.send();

        },
        build: function ( jsonData, isInitialPost ) {
            var hbsResultsContainer = document.getElementById( dvf.dealersearch.hbs.results.container ),
                hbsZipContainer = document.getElementById( dvf.dealersearch.hbs.zipcodes.container );
            hbsResultsContainer.innerHTML = dvf.dealersearch.hbs.results.compiled( jsonData );
            if ( isInitialPost === true ) {
                hbsZipContainer.innerHTML = dvf.dealersearch.hbs.zipcodes.compiled( jsonData );
            }
            var spinner = document.querySelector(".js-findlawyer-loading-spinner");
            spinner.parentNode.removeChild( spinner );

        }
    }
};
